import { render, staticRenderFns } from "./RulesVerification.vue?vue&type=template&id=0381ee97&"
import script from "./RulesVerification.vue?vue&type=script&lang=js&"
export * from "./RulesVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports